<template>
  <b-modal
    :id="id"
    centered
    hide-header
    hide-footer
    no-enforce-focus
    no-close-on-backdrop
    @show="reset"
  >
    <b-form
      @submit.prevent="onSubmit"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem
      "
    >
      <h2 class="mt-3">加入行動按鈕</h2>
      <ValidationObserver ref="form" class="w-100">
        <AGCInput
          v-model.trim="titleInput"
          name="標題"
          label="標題"
          rules="required|max:50"
          required
          autofocus
        ></AGCInput>
        <AGCInput
          v-model.trim="urlInput"
          name="URL"
          label="URL"
          rules="required"
          required
        ></AGCInput>
      </ValidationObserver>
      <div style="width: 100%; display: flex; gap: 1.5rem" class="my-2">
        <b-button
          @click="$bvModal.hide(id)"
          variant="outline-primary"
          style="flex: 1"
        >
          取消
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          style="flex: 1"
        >
          確認
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import AGCInput from '@/components/form/AGCInput.vue';
import formMixin from '@/mixins/form';
import { BButton, BForm } from 'bootstrap-vue';

export default {
  mixins: [formMixin],
  components: {
    AGCInput,
    BButton,
    BForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    htmlCallback: {
      type: Function,
    },
  },
  data: () => ({
    titleInput: '',
    urlInput: '',
  }),
  computed: {
    generatedHTML() {
      return `<p style="text-align: center">
        <a
          href="${this.urlInput}"
          style="
            padding: 12px 24px;
            line-height: 36px;
            font-size: 24px;
            font-weight: 700;
            color: #fff;
            background: #351c75;
            border: 1px solid #d4d0df;
            border-radius: 40px;
            box-shadow: 4px 4px 0px 0px rgba(50,50,50,.2);
            transition: all .15s ease-out;
            text-decoration: none;
          "
          target="_blank"
          rel="noopener"
        >${this.titleInput}</a>
      </p><p></p>`;
    },
  },
  methods: {
    reset() {
      this.titleInput = '';
      this.urlInput = '';
    },
    async onSubmit() {
      if ((await this.validate().toPromise()) === undefined) {
        return;
      }
      this.htmlCallback(this.generatedHTML);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
